<template lang="pug">
    .page
      section.section-dark
        .text-center
          b-container.py-5
            h1 Artists
            p
              | Get to know our local selection of artists by reading more about them and viewing their work.
              | From emerging to established artists, Wall is proud of our growing community of creators
              | and the role we play in introducing their talent to South Africa.
      section
        .container
          content-loader(:height="7", v-if="alert.loading")
          .row.py-3(v-else-if="artists && artists.length > 0")
            .col-md-6.py-3.my-2(v-for="artist in artists", :key="artist.id")
              router-link(:to="{ name: 'gallery', query: { artist: artist.id} }")
                .row
                  .col-4.text-center
                    b-button.piece.mx-1(:style="{'background-image': `url(${getImageUrl(artist.preview_piece_url, 100)})`}")
                    //- div.piece.dummy.bg-alt.p-3.center-xy(v-else="")
                      img.w-100(src="@/assets/images/branding/logo_icon_grey.svg")
                  .col-8.d-flex.align-items-center
                    div.w-100
                      h3.mt-1.mb-1 {{ artist.name }}
                      p.my-1 {{ artist.base }}
            .col-12.my-3
          nothing(v-else="", text="COMING SOON")
      section.section-dark
        .container.text-center
          h1 Are You an Artist?
          p Apply now to have your work showcased on our curated platform, while enjoying some of the lowest commissions in the industry.
          b-button.btn-outline-light(:to="{name: 'artist-register'}") ARTIST SIGN-UP
</template>

<script>
// import { mapActions, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  metaInfo() {
    return {
      title: 'Artists',
      // meta: [
      //   {
      //     name: 'description',
      //     content: 'I will not be',
      //   },
      // ],
    };
  },
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showFilter: true,
      allArtists: [],
      filter: {
        status: ['pending', 'active'],
      },
    };
  },
  computed: {
    artists() {
      return this.allArtists.filter(item => item.preview_piece_url);
    },
  },
  methods: {
  },
  async created() {
    try {
      this.loading();
      this.allArtists = await apiService.getArtists(this.filter);
      this.clear();
    } catch (error) {
      this.error('Could not retrieve artists');
    }
  },
};
</script>

<style lang="scss" scoped>

.piece {
  width: 50px;
  border-radius: 50%;
  background-position: center;
  @include desktop {
    width: 80px;
  }
  aspect-ratio: 1 / 1;
  @supports not (aspect-ratio: 1 / 1) {
    width: 100px;
    height: 100px;
  }
}
.thumbnail {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Artists.vue